export default __webpack_public_path__ + "static/media/coins.2fa6e912.svg";